"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defaultsTo(prop, defaultValue) {
  return prop === undefined ? defaultValue : prop;
}

var className = function className(props) {
  return (0, _classnames.default)('Container', {
    'Container--full-height': defaultsTo(props.useFullHeight, false),
    'Container--no-bottom-padding': !props.useBottomPadding,
    'Container--no-top-padding': !props.useTopPadding,
    'Container--no-padding': props.noPadding
  }, {
    'Container--small': props.size === 'small',
    'Container--xsmall': props.size === 'xsmall'
  }, props.className);
};

var Container = function Container(props) {
  var style = props.style,
      children = props.children;
  return _react.default.createElement("div", {
    className: className(props),
    style: style
  }, children);
};

var _default = Container;
exports.default = _default;